// third-party
import { combineReducers } from "redux";

// project import
import auth from "./auth";
import pop from "./pop";
import accessControl from "./accessControl";
import lang_dir from "./lang_dir";
import loading from "./loading";
import user from "./user";
// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({
  auth,
  pop,
  accessControl,
  lang_dir,
  loading,
  user
});

export default reducers;
